import { render, staticRenderFns } from "./editDictDataButton.vue?vue&type=template&id=560fa443&"
import script from "./editDictDataButton.vue?vue&type=script&lang=js&"
export * from "./editDictDataButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports